<nav class="sidebar-nav">
  <ul id="sidebarnav" class="p-3">
    <!-- First level menu -->
      <li class="sidebar-item" [class.active]="showMenu === sidebarnavItem.title"
      *ngFor="let sidebarnavItem of sidebarnavItems"
      [routerLinkActive]="sidebarnavItem.submenu.length != 0 ? '' : 'active'">
      <div class="nav-small-cap" *ngIf="sidebarnavItem.extralink === true">{{sidebarnavItem.title}}</div>
      <a class="sidebar-link waves-effect waves-dark"
          [routerLink]="sidebarnavItem.class === '' ? [sidebarnavItem.path] : null"
          [ngClass]="[sidebarnavItem.class]" *ngIf="!sidebarnavItem.extralink;"
          (click)="addExpandClass(sidebarnavItem.title)"
          [routerLinkActive]="sidebarnavItem.submenu.length != 0 ? '' : 'active'">
          <i [ngClass]="[sidebarnavItem.icon]"></i>
          <span class="hide-menu">{{sidebarnavItem.title}}</span>
      </a>
      <ul aria-expanded="false" class="collapse first-level" *ngIf="sidebarnavItem.submenu.length"
        [ngClass]="{ in: showMenu === sidebarnavItem.title }">
        <li class="sidebar-item m-1" *ngFor="let sidebarnavSubItem of sidebarnavItem.submenu"
          (click)="sidebarnavSubItem.submenu.length != 0 ? '' : handleNotify()"
          [class.active]="showSubMenu === sidebarnavSubItem.title" [routerLinkActive]="
            sidebarnavSubItem.submenu.length > 0 ? '' : 'active'
          ">
          <div class="nav-small-cap" [ngClass]="[sidebarnavSubItem.class]" *ngIf="sidebarnavItem.extralink === true">
            {{ sidebarnavSubItem.title }}
          </div>
          <a class="sidebar-link" [routerLink]="
              sidebarnavSubItem.submenu.length > 0
                ? null
                : [sidebarnavSubItem.path]
            " [routerLinkActive]="
              sidebarnavSubItem.submenu.length > 0 ? '' : 'router-link-active'
            " (click)="addActiveClass(sidebarnavSubItem.title)">
            <i [ngClass]="[sidebarnavSubItem.icon]"></i>
            <span class="hide-menu">{{ sidebarnavSubItem.title }}</span>
          </a>
          <ul aria-expanded="false" class="collapse Second-level" *ngIf="sidebarnavSubItem.submenu.length > 0"
            [ngClass]="{ in : showSubMenu === sidebarnavSubItem.title }">
            <li class="sidebar-item m-1" *ngFor="let sidebarnavSubsubItem of sidebarnavSubItem.submenu"
              [routerLinkActive]="sidebarnavSubsubItem.submenu.length > 0 ? '' : 'active'">
              <div class="nav-small-cap" *ngIf="sidebarnavItem.extralink === true">
                {{ sidebarnavSubsubItem.title }}
              </div>
              <a class="sidebar-link" [routerLink]="[sidebarnavSubsubItem.path]"
                *ngIf="!sidebarnavSubsubItem.extralink;"
                [routerLinkActive]="sidebarnavSubsubItem.submenu.length > 0 ? '' : 'router-link-active'">
                <i [ngClass]="[sidebarnavSubsubItem.icon]"></i>
                <span class="hide-menu">{{sidebarnavSubsubItem.title}}</span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </li>
    <li class="text-center p-3 upgrade-btn">
      <div>
        <strong>Recommendation:</strong><br />
        Please use the latest version
        of a modern browser (Chrome, Firefox, Edge) for an optimal
        problem-free experience on this website.
      </div>
    </li>
  </ul>
</nav>